import { Account } from './account.model';

export class AccountsResult {
    constructor(public accounts: Account[]) {}
}

export function defaultAccountsResult(): AccountsResult {
    return {
        accounts: undefined
    };
}
